<div class="detailDescription"></div>
<p class="detailHeading">
    <span [innerHTML]="heading"></span>
</p>
